import { createReducer, on } from '@ngrx/store';
import * as IotAssetActions from './iotAsset.actions';
import { IotAsset } from '../../models/iotAssetsModel.data';
import { AssetMappingConfig } from '../../models/asset-config.model';



export interface IotAssetState {
  iotAssets: IotAsset[];
  error: any;
  isLoading: boolean;
  isRefreshing: boolean;
  totalAssets: number; // Totale generale degli asset
  mappingConfig: AssetMappingConfig | null; // Configurazione di mapping dei campi
  configLoading: boolean; // Loading state per la configurazione
  configError: any; // Errore per la configurazione
}

export const initialState: IotAssetState = {
  iotAssets: [],
  error: null,
  isLoading: false,
  isRefreshing: false,
  totalAssets: 0,
  mappingConfig: null,
  configLoading: false,
  configError: null,
};

export const iotAssetReducer = createReducer(
  initialState,
  on(IotAssetActions.loadIotAssets, (state) => ({ ...state, isLoading: true })),
  on(IotAssetActions.loadIotAssetsSuccess, (state, { iotAssets }) => ({
    ...state,
    iotAssets,
    totalAssets: iotAssets.length,
    isLoading: false,
  })),
  on(IotAssetActions.loadIotAssetsFailure, (state, { error }) => ({
    ...state,
    error,
    isLoading: false,
  })),
  on(IotAssetActions.refreshIotAssets, (state) => ({ ...state, isRefreshing: true })),
  on(IotAssetActions.refreshIotAssetsSuccess, (state, { iotAssets }) => ({
    ...state,
    iotAssets: iotAssets.map((newAsset) => {
      const existingAsset = state.iotAssets.find((asset) => asset.plate === newAsset.plate);
      return {
        ...newAsset,
        vehicle_selected: existingAsset ? existingAsset.vehicle_selected : false,
      };
    }),
    totalAssets: iotAssets.length,
    isRefreshing: false,
  })),
  on(IotAssetActions.refreshIotAssetsFailure, (state, { error }) => ({
    ...state,
    error,
    isRefreshing: false,
  })),
  on(IotAssetActions.setLoading, (state, { isLoading }) => ({ ...state, isLoading })),
  on(IotAssetActions.setRefreshing, (state, { isRefreshing }) => ({ ...state, isRefreshing })),
  on(IotAssetActions.updateIotAssetSelected, (state, { vin, selected }) => ({
    ...state,
    iotAssets: state.iotAssets.map((asset) =>
      asset.vin === vin
        ? {
            ...asset,
            vehicle_selected: selected,
          }
        : asset
    ),
  })),
  on(IotAssetActions.deselectAllIotAssets, (state) => ({
    ...state,
    iotAssets: state.iotAssets.map((asset) => ({
      ...asset,
      vehicle_selected: false,
    })),
  })),

  // Gestione configurazione di mapping
  on(IotAssetActions.loadMappingConfig, (state) => ({
    ...state,
    configLoading: true,
    configError: null
  })),
  on(IotAssetActions.loadMappingConfigSuccess, (state, { mappingConfig }) => ({
    ...state,
    mappingConfig,
    configLoading: false,
    configError: null,
  })),
  on(IotAssetActions.loadMappingConfigFailure, (state, { error }) => ({
    ...state,
    configError: error,
    configLoading: false,
  })),
  on(IotAssetActions.saveMappingConfig, (state) => ({
    ...state,
    configLoading: true,
    configError: null
  })),
  on(IotAssetActions.saveMappingConfigSuccess, (state, { mappingConfig }) => ({
    ...state,
    mappingConfig,
    configLoading: false,
    configError: null,
  })),
  on(IotAssetActions.saveMappingConfigFailure, (state, { error }) => ({
    ...state,
    configError: error,
    configLoading: false,
  })),
  on(IotAssetActions.updateMappingConfig, (state, { mappingConfig }) => ({
    ...state,
    mappingConfig,
  })),
  on(IotAssetActions.updateFieldVisibility, (state, { fieldName, visible }) => ({
    ...state,
    mappingConfig: state.mappingConfig ? {
      ...state.mappingConfig,
      fields: {
        ...state.mappingConfig.fields,
        [fieldName]: {
          ...state.mappingConfig.fields[fieldName],
          visible
        }
      },
      lastUpdated: new Date().toISOString()
    } : null
  }))
);
